const SkipToContent = ({ targetId = "main-content" }) => (
  <a className="skip-to-content" href={`#${targetId}`}>
    Skip to main content
  </a>
);

export default SkipToContent;
